// Defined in separate constants file to avoid circular dependency.
export const END_ACTIONS_COLUMN_ID = 'endActions';
